/**
 * Header section of chat content view.
 */
import type { ReactNode } from 'react'

import { ChatHeaderToolbar } from '@/components/chat/chat-header-toolbar.organism'
import type { ChatViewHandlers, ChatViewState, ChatViewTitleEditState } from './chat.view.hook'

interface ChatHeaderSectionProps {
  state: ChatViewState
  handlers: ChatViewHandlers
  titleEditState: ChatViewTitleEditState
}

export const ChatHeaderSection = ({
  state,
  handlers,
  titleEditState,
}: ChatHeaderSectionProps): ReactNode => (
  <ChatHeaderToolbar
    title={state.conversation?.name ?? 'New Conversation'}
    participantList={state.participantList}
    pinnedMessageList={state.pinnedMessageList}
    isJumping={state.jumpingPinnedMessageId !== null}
    jumpingMessageId={state.jumpingPinnedMessageId}
    isTitleEditing={titleEditState.isTitleEditing}
    isTitleSaving={titleEditState.isTitleSaving}
    onTitleEditStart={handlers.handleTitleEditStart}
    onTitleSave={handlers.handleTitleSave}
    onTitleEditCancel={handlers.handleTitleEditCancel}
    onParticipantClick={handlers.handleParticipantClick}
    onPinnedMessageClick={handlers.handlePinnedMessageClick}
    onSettings={handlers.handleSettings}
    onArchive={handlers.handleArchive}
    onInvite={handlers.handleInvite}
    onLeave={handlers.handleLeave}
  />
)
